// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__dYTEm","quiver-spinner__spin":"Spinner_quiver-spinner__spin__0aUWD","error":"Spinner_error__FeUpd"};